<div class="mct-flex mct-row mct-wrap mct-gap-10" data-cy="divExpressionContainer">
  <div class="expression-72px">
    <select [hidden]="binarySelectorHidden" [(ngModel)]="searchExpression.BinaryOperator" class="form-control">
      <option [ngValue]="binaryOperatorEnum.And">{{ 'shared.widgets.expression.binary-operator.and' | translate |
        titlecase }}</option>
      <option [ngValue]="binaryOperatorEnum.Or">{{ 'shared.widgets.expression.binary-operator.or' | translate |
        titlecase }}</option>
    </select>
  </div>
  <div class="mct-basis-33 mct-flex-0-0-230px-lt-md">
    <select [(ngModel)]="searchExpression.Field" class="form-control"
      (change)="handleExpressionFieldChange($event.target.value)" data-cy="selectExpressionOption">
      <option value="">{{ 'common.select' | translate | titlecase }}...</option>
      <option *ngFor="let option of childOptions; let i = index" [value]="option.value">{{ option.name }}</option>
    </select>
  </div>
  <div class="expression-170px" *ngIf="selectedOption && !isBooleanType">
    <select [(ngModel)]="searchExpression.FieldValueOperator" class="form-control"
      data-cy="selectExpressionOptionOperator" (change)="handleFieldValueOperatorChange()">
      <option [ngValue]="fieldValueOperatorOptions.Equals">
        {{ 'shared.widgets.expression.value-operator.equals' | translate | titlecase }}
      </option>
      <option [ngValue]="fieldValueOperatorOptions.Contains" *ngIf="!isDateType">
        {{ 'shared.widgets.expression.value-operator.contains' | translate | titlecase }}
      </option>
      <option [ngValue]="fieldValueOperatorOptions.DoesNotcontain" *ngIf="!isDateType">
        {{ 'shared.widgets.expression.value-operator.does-not-contain' | translate | titlecase }}
      </option>
      <option [ngValue]="fieldValueOperatorOptions.NotEqual">
        {{ 'shared.widgets.expression.value-operator.not-equal' | translate | titlecase }}
      </option>
      <option [ngValue]="fieldValueOperatorOptions.StartsWith" *ngIf="!isDateType">
        {{ 'shared.widgets.expression.value-operator.starts-with' | translate | titlecase }}
      </option>
      <option [ngValue]="fieldValueOperatorOptions.GreaterThan">
        {{ 'shared.widgets.expression.value-operator.greater-than' | translate | titlecase }}
      </option>
      <option [ngValue]="fieldValueOperatorOptions.LessThan">
        {{ 'shared.widgets.expression.value-operator.less-than' | translate | titlecase }}
      </option>
      <option [ngValue]="fieldValueOperatorOptions.InPeriod" *ngIf="isDateType && !excludeExtraDateOptions">
        {{ 'shared.widgets.expression.value-operator.in-the-period' | translate | titlecase }}
      </option>
      <option [ngValue]="fieldValueOperatorOptions.DaysForward" *ngIf="isDateType && !excludeExtraDateOptions">
        {{ 'shared.widgets.expression.value-operator.number-of-days-until' | translate | titlecase }}
      </option>
      <option [ngValue]="fieldValueOperatorOptions.DaysBack" *ngIf="isDateType && !excludeExtraDateOptions">
        {{ 'shared.widgets.expression.value-operator.number-of-days-since' | translate | titlecase }}
      </option>
      <option [ngValue]="fieldValueOperatorOptions.Between" *ngIf="isDateType && showBetweenDateOption">
        {{ 'shared.widgets.expression.value-operator.between' | translate | titlecase }}
      </option>
    </select>
  </div>
  <div class="mct-flex-1-1-0 mct-flex-0-0-230px-lt-md" *ngIf="selectedOption && isStringType">
    <input type="text" *ngIf="!dropdownOptions?.length" [(ngModel)]="searchExpression.Value" class="form-control" />
    <select *ngIf="dropdownOptions?.length" [(ngModel)]="searchExpression.Value" class="form-control">
      <option *ngFor="let ddOption of dropdownOptions" [value]="ddOption.value">{{ ddOption.label || ddOption.value }}
      </option>
    </select>
  </div>
  <div class="mct-flex-1-1-0 mct-flex-0-0-230px-lt-md" *ngIf="selectedOption && isDateType">
    <wl-date-selector *ngIf="searchExpression.FieldValueOperator < 5" [(ngModel)]="selectedDate"
      (onDateChanged)="selectedDateChanged($event)"></wl-date-selector>
    <select *ngIf="searchExpression.FieldValueOperator == 5" [(ngModel)]="searchExpression.Value" class="form-control">
      <option value="" disabled>{{ 'shared.widgets.expression.date-period-options.select-period' | translate | titlecase
        }}</option>
      <option [value]="datePeriodEnum.Last1Day">
        {{ 'shared.widgets.expression.date-period-options.last-1-day' | translate | titlecase }}
      </option>
      <option [value]="datePeriodEnum.Last7Days">
        {{ 'shared.widgets.expression.date-period-options.last-7-days' | translate | titlecase }}
      </option>
      <option [value]="datePeriodEnum.Last30Days">
        {{ 'shared.widgets.expression.date-period-options.last-30-days' | translate | titlecase }}
      </option>
      <option [value]="datePeriodEnum.MonthToDate">
        {{ 'shared.widgets.expression.date-period-options.month-to-date' | translate | titlecase }}
      </option>
      <option [value]="datePeriodEnum.YearToDate">
        {{ 'shared.widgets.expression.date-period-options.year-to-date' | translate | titlecase }}
      </option>
      <option [value]="datePeriodEnum.Next7Days">
        {{ 'shared.widgets.expression.date-period-options.next-7-days' | translate | titlecase }}
      </option>
      <option [value]="datePeriodEnum.Next30Days">
        {{ 'shared.widgets.expression.date-period-options.next-30-days' | translate | titlecase }}
      </option>
      <option [value]="datePeriodEnum.Next60Days">
        {{ 'shared.widgets.expression.date-period-options.next-60-days' | translate | titlecase }}
      </option>
    </select>
    <wl-date-selector *ngIf="searchExpression.FieldValueOperator == 6" [(ngModel)]="selectedDate"
      (onDateChanged)="selectedDateChanged($event)"></wl-date-selector>
    <span class="mh-10" *ngIf="searchExpression.FieldValueOperator == 6">
      {{ 'common.and' | translate | titlecase }}
    </span>
    <wl-date-selector *ngIf="searchExpression.FieldValueOperator == 6" [(ngModel)]="selectedSecondDate"
      (onDateChanged)="selectedSecondDateChanged($event)"></wl-date-selector>
    <input class="form-control" *ngIf="searchExpression.FieldValueOperator > 6" type="number"
      [(ngModel)]="searchExpression.Value" />
  </div>
  <div class="mct-flex-1-1-0" *ngIf="selectedOption && isBooleanType">
    <label><input type="radio" [(ngModel)]="searchExpression.Value" [name]="searchExpression.Field" value="true"
        data-cy="radioExpressionOption" />
      {{ trueLabel || ('common.true' | translate | titlecase) }}</label>
    &nbsp;
    <label><input type="radio" [(ngModel)]="searchExpression.Value" [name]="searchExpression.Field" value="false"
        data-cy="radioExpressionOption" />
      {{ falseLabel || ('common.false' | translate | titlecase) }}</label>
  </div>
  <div class="mct-flex-1-1-0" *ngIf="selectedOption && isNumericType">
    <input type="number" [(ngModel)]="searchExpression.Value" class="form-control" />
  </div>
</div>
